
<template>
  <div class="record_box">
    <div class="br_box">
      <span class="banner"></span>
    </div>
    <div class="bag_title">
      <p class="name">{{json.customizeName}}P超值权益礼包</p>
      <p class="money">￥{{json.price}} <span class="readPeople right">{{json.receiveCount}}人已领取</span></p>
    </div>
    <div class="info">
      <p class="title">权益介绍</p>
      <ul>
        <li v-for="(item,index) in tutorial"
            :key="index">
          <img class="logo1"
               :src="item.url" />{{item.description}}</li>
      </ul>
    </div>
    <div class="btn_box">
      <span class="btn"
            @click="toPage">立即领取</span>
    </div>

    <div class="shadow"
         v-if="isShowTost"></div>
    <div class="toast"
         v-if="isShowTost">
      <span class="close"
            @click="toHide"></span>
      <span class="label">卡号</span>
      <p class="num"><span class="cardNum">{{copyCard}}</span> <span class="copy_btn"
              :class="{'isGray':isGray}"
              v-clipboard:copy="copyCard"
              v-clipboard:success="onCopy"
              v-clipboard:error="onError">{{copyBtn}}</span></p>
      <span class="label">密码(请牢记在心里～):</span>
      <p class="num"><span class="passWord">{{copyPass}}</span></p>
      <p class="click_btn"
         @click="toUse">立即使用</p>
    </div>

    <MessageInfo :propJson="propJson"
                 @sureClick="sureClick" />
  </div>
</template>

<script>
import MessageInfo from '@/components/messageInfo'
export default {
  components: {
    MessageInfo
  },
  data () {
    return {
      isShowTost: false,
      money: '',
      id: '',
      goldId: '',
      json: {},
      isGray: false,
      balanceList: [],
      tutorial: [],
      copyCard: '',
      copyPass: '',
      copyBtn: '复制',
      propJson: {
        title: '提示',
        message: '获取卡密失败，请重试或联系客服',
        cacleBtn: '稍后查看',
        sureBtn: '刷新重试',
        showToast: false,
        isSecond: false,
      },
    }
  },
  mounted () {
    this.util.title('礼包详情');
    this.id = this.$route.query.id
    this.goldId = this.$route.query.goldId;
    this.getDetail();
  },
  methods: {
    onCopy (e) {
      this.isGray = true;
      this.copyBtn = '已复制'
      this.util.toast({ msg: '复制成功' })
    },
    onError (e) {
      this.util.toast({ msg: '复制失败' })
    },
    sureClick () {//刷新重试
      this.getGifs();
    },
    getDetail () {//
      let _this = this;
      this.$get('/app/valueAdded/gifts/' + this.id, {})
        .then(res => {
          var e = res;
          if (e.code == 200) {
            _this.json = e.data;
            _this.tutorial = JSON.parse(e.data.tutorial)
          }
          else {
            _this.util.toast({ msg: e.message })
          }
        })
        .catch(error => { });
    },
    toPage () {
      this.getGifs();
    },
    toUse () {
      window.location.href = "http://demo.huacai189.com/"
    },
    toHide () {
      this.isShowTost = false;
    },
    getGifs () {
      let _this = this;
      this.$post('/app/valueAdded/receiveGift/' + this.goldId, {})
        .then(res => {
          var e = res;
          if (e.code == 200) {
            _this.isShowTost = true;
            _this.copyCard = res.data.cardNum;
            _this.copyPass = res.data.password;
          }
          else {
            _this.propJson.showToast = true;
          }
        })
        .catch(error => { });
    },
  }

}
</script>
<style scoped>
.record_box {
  background: #f7f7f7;
  width: 100%;
  /* height: 100%; */
  padding-bottom: 1.5rem;
}
.br_box {
  padding: 0.15rem;
  padding-bottom: 0;
  height: 1.26rem;
}
.banner {
  display: inline-block;
  background: url('../../assets/img/vip/card/bag_bg.png') no-repeat center
    center;
  background-size: 100% 100%;
  height: 1.11rem;
  width: 100%;
}
.bag_title {
  background: #fff;
  padding: 0.18rem 0.15rem;
  padding-bottom: 0.1rem;
  margin-bottom: 0.1rem;
}
.bag_title .name {
  font-size: 0.17rem;
  color: #333;
  font-family: PingFangSC;
  font-weight: 500;
}
.bag_title .money {
  color: #ff514a;
  font-size: 0.27rem;
  font-family: PingFangSC;
  font-weight: 500;
  position: relative;
}
.bag_title .readPeople {
  font-size: 0.12rem;
  color: #999;
  position: absolute;
  bottom: 0.05rem;
  right: 0;
}
.info {
  padding: 0.15rem;
  background: #ffffff;
}
.info .title {
  color: #333;
  font-size: 0.14rem;
  margin-bottom: 0.1rem;
  font-family: PingFangSC;
  font-weight: 500;
}
.info ul li {
  margin-bottom: 0.1rem;
}
.logo1,
.logo2,
.logo3,
.logo4,
.logo5 {
  display: inline-block;
  background: url('../../assets/img/vip/card/bag_icon1.png') no-repeat center
    center;
  background-size: 100% 100%;
  width: 0.24rem;
  height: 0.24rem;
  margin-right: 0.17rem;
  top: 0.07rem;
  position: relative;
}
.logo2 {
  background: url('../../assets/img/vip/card/bag_icon2.png') no-repeat center
    center;
  background-size: 100% 100%;
}
.logo3 {
  background: url('../../assets/img/vip/card/bag_icon3.png') no-repeat center
    center;
  background-size: 100% 100%;
}
.logo4 {
  background: url('../../assets/img/vip/card/bag_icon4.png') no-repeat center
    center;
  background-size: 100% 100%;
}
.logo5 {
  background: url('../../assets/img/vip/card/bag_icon5.png') no-repeat center
    center;
  background-size: 100% 100%;
}
.btn_box {
  text-align: center;
  /* background: #f7f7f7; */
  position: fixed;
  width: 100%;
  bottom: 0.3rem;
}
.btn {
  display: inline-block;
  width: 85%;
  margin: 0 auto;
  color: #fff;
  height: 0.5rem;
  text-align: center;
  background: linear-gradient(
    132deg,
    rgba(89, 163, 252, 1) 0%,
    rgba(60, 100, 246, 1) 100%
  );
  border-radius: 25px;
  line-height: 0.5rem;
  font-size: 0.17rem;
}

.shadow {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 1);
  opacity: 0.4;
  z-index: 11;
}
.toast {
  position: fixed;
  top: 1.05rem;
  left: 50%;
  background: #fff;
  z-index: 111;
  width: 2.95rem;
  transform: translate(-50%, 0);
  padding-top: 0.44rem;
  border-radius: 10px;
  padding: 0 0.16rem;
  padding-bottom: 0.3rem;
  padding-top: 0.55rem;
}
.toast .label {
  color: #666;
  font-size: 0.16rem;
}
.toast .num {
  color: #333;
  font-size: 0.18rem;
  background: rgba(215, 232, 254, 0.2);
  margin-bottom: 0.34rem;
  margin-top: 0.13rem;
  border-radius: 4px;
  padding: 0.02rem 0.06rem;
}
.toast .copy_btn {
  color: #4f8cfa;
  font-size: 0.17rem;
  float: right;
}
.toast .click_btn {
  height: 0.17rem;
  font-size: 0.17rem;
  font-family: PingFangSC;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  line-height: 0.17rem;
  width: 2.45rem;
  height: 0.5rem;
  background: linear-gradient(
    132deg,
    rgba(89, 163, 252, 1) 0%,
    rgba(60, 100, 246, 1) 100%
  );
  border-radius: 25px;
  text-align: center;
  line-height: 0.5rem;
}
.toast .close {
  display: inline-block;
  width: 0.16rem;
  height: 0.16rem;
  background: url('../../assets/img/afterLoan/close_btn.png') no-repeat center
    center;
  background-size: 100% 100%;
  position: absolute;
  right: 0.16rem;
  top: 0.19rem;
}
.toast .isGray {
  color: #999;
}
</style>
